import classNames from 'classnames';
import styles from './ArticleAuthor.module.scss';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { ArticleBylineProps } from '../ArticleByline/ArticleByline';

export interface ArticleAuthorProps extends ArticleBylineProps {
	bio: string;
	email: string;
}

export const UI_ArticleAuthor = ({ className, fullName, workTitle, email, bio }: ArticleAuthorProps) => (
	<footer className={classNames(styles.ArticleAuthor, className)}>
		<div className={styles.ArticleAuthor_name}>
			<UI_Heading headingLevel="h4" style="md">
				{fullName}
			</UI_Heading>
		</div>
		<div className={styles.ArticleAuthor_title}>{workTitle}</div>
		<div className={styles.ArticleAuthor_email}>
			<UI_Link className={styles.ArticleAuthor_link} url={`mailto:${email}`}>
				{email}
			</UI_Link>
		</div>
		<div className={styles.ArticleAuthor_bio}>{bio}</div>
	</footer>
);
